<div class="processing">
    <p>
        {{ message | translate }}
    </p>
    <span class="material-symbols-outlined"> hourglass_top </span>
</div>
